import React, { useState } from "react";
import Icon1 from "../images/icons/Icon1";
import Icon2 from "../images/icons/Icon2";

const Tutorial = () => {
  const [mode, setMode] = useState(null);
  const lostVideoId = "OUaLkzs_fiQ";
  const foundVideoId = "VPulZu1ntt0";

  const YouTubeEmbed = (videoId) => {
  const src = `https://www.youtube-nocookie.com/embed/${videoId}?rel=0`;
  return (
    <div className="w-full aspect-video">
      <iframe
        title="YouTube video player"
        src={src}
        className="w-full h-full border-0 rounded-lg"
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  );
};

  return (
    <div className="w-full h-full pb-20 nav:py-20 px-4 bg-orange-50">
      <div className="w-full flex-col text-center justify-center items-center ">
        <h2 className="text-3xl nav:text-4xl font-main font-bold pb-8">
          ¿Qué quieres hacer?
        </h2>
        <div className="flex justify-center gap-8 sm:gap-4 mt-4 px-2">
          <button
            onClick={() => {
              setMode("lost");
            }}
            className={`flex items-center gap-3 px-6 py-4 rounded-full transition ${
              mode === "lost"
                ? "bg-secondary text-white font-main"
                : "bg-white text-gray-700 font-main"
            }`}
          >
            <Icon2 className="w-10 h-10" />
            <span className="font-main text-md nav:text-xl font-bold">
              Perdí mi mascota
            </span>
          </button>
          <button
            onClick={() => {
              setMode("found");
            }}
            className={`flex items-center gap-3 px-6 py-4 rounded-full  transition ${
              mode === "found"
                ? "bg-secondary text-white"
                : "bg-white text-gray-700"
            }`}
          >
            <Icon1 className="w-10 h-10" />
            <span className="font-main text-md nav:text-xl font-bold">
              Encontré una mascota
            </span>
          </button>
        </div>
        <section className="w-full flex items-center justify-center mt-6">
  {mode && (
    <div className="w-full max-w-4xl mx-auto">
      {mode === "lost" ? (
        <>{YouTubeEmbed(lostVideoId)}</>
      ) : (
        <>{YouTubeEmbed(foundVideoId)}</>
      )}
    </div>
  )}
</section>
      </div>
    </div>
  );
};

export default Tutorial;
